import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://zthnfbjrrsdfpaiwgpdp.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp0aG5mYmpycnNkZnBhaXdncGRwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0MzU3ODMsImV4cCI6MjA3NTAxMTc4M30.TZ-TN1n1H4FWlE4L1J3Rf2E3T8v8afHGRy0nHxlTk6I';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
